import {
  aCustomStatusCount,
  anInsightCountsByStatusDataPoint,
  anInsightStatus,
  mockInsightStatusMetricsQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockInsightCountsByStatus = [
  anInsightCountsByStatusDataPoint({
    value: {
      __typename: 'InsightCountByStatus',
      new: 12,
      inProgress: 10,
      closed: 5,
      other: 7,
      otherDetail: [
        aCustomStatusCount({
          statusId: 1234,
          statusName: 'validation',
          count: 5,
        }),
        aCustomStatusCount({
          statusId: 1235,
          statusName: 'triage',
          count: 2,
        }),
        aCustomStatusCount({
          statusId: 1236,
          statusName: 'containment',
          count: 1,
        }),
        aCustomStatusCount({
          statusId: 1237,
          statusName: 'unknown',
          count: 1,
        }),
      ],
    },
  }),
  anInsightCountsByStatusDataPoint({
    value: {
      __typename: 'InsightCountByStatus',
      new: 2,
      inProgress: 6,
      closed: 3,
      other: 1,
      otherDetail: [
        aCustomStatusCount({
          statusId: 1234,
          statusName: 'validation',
          count: 1,
        }),
        aCustomStatusCount({
          statusId: 1235,
          statusName: 'triage',
          count: 0,
        }),
        aCustomStatusCount({
          statusId: 1236,
          statusName: 'containment',
          count: 2,
        }),
      ],
    },
  }),
];

export const mockInsightStatuses = [
  anInsightStatus({
    id: '3',
    name: 'new',
    displayName: 'New',
    color: '#F77D74',
  }),
  anInsightStatus({
    id: '1234',
    name: 'validation',
    displayName: 'Validation',
    color: '#50CAF2',
  }),
  anInsightStatus({
    id: '1235',
    name: 'triage',
    displayName: 'Triage',
    color: '#066180',
  }),
  anInsightStatus({
    id: '1236',
    name: 'containment',
    displayName: 'Containment',
    color: '#8ECC1B',
  }),
  anInsightStatus({
    id: '2',
    name: 'closed',
    displayName: 'Closed',
    color: '#27EFB5',
  }),
  anInsightStatus({
    id: '1237',
    name: 'unknown',
    displayName: 'Unknown',
    color: '#000000',
  }),
];

export const handlers = [
  mockInsightStatusMetricsQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightCountsByStatus: mockInsightCountsByStatus,
          insightStatuses: mockInsightStatuses,
        },
      });
    }
  ),
];
